import {
  DUPLICATE_COMPONENT_ACROSS_LOCALES_STARTED,
  DUPLICATE_COMPONENT_ACROSS_LOCALES_ENQUEUE_STARTED,
  DUPLICATE_COMPONENT_ACROSS_LOCALES_ENQUEUE_SUCCEEDED,
  DUPLICATE_COMPONENT_ACROSS_LOCALES_PROGRESSED,
  DUPLICATE_COMPONENT_ACROSS_LOCALES_FAILED,
} from '@packages/systems/designer/actions';
import type {DesignerActionFromCreator} from '@packages/systems/designer/flux';
import type {DuplicateComponentPayload} from '@packages/systems/component-duplicate';
import {createAction} from '@packages/utilities/create-action';

export const duplicateComponentAcrossLocalesStarted = createAction<
  typeof DUPLICATE_COMPONENT_ACROSS_LOCALES_STARTED,
  DuplicateComponentPayload
>(DUPLICATE_COMPONENT_ACROSS_LOCALES_STARTED);

export type DuplicateComponentAcrossLocalesStartedAction =
  DesignerActionFromCreator<typeof duplicateComponentAcrossLocalesStarted>;

export const duplicateComponentAcrossLocalesEnqueueStarted = createAction<
  typeof DUPLICATE_COMPONENT_ACROSS_LOCALES_ENQUEUE_STARTED,
  DuplicateComponentPayload
>(DUPLICATE_COMPONENT_ACROSS_LOCALES_ENQUEUE_STARTED);

export type DuplicateComponentAcrossLocalesEnqueueStartedAction =
  DesignerActionFromCreator<
    typeof duplicateComponentAcrossLocalesEnqueueStarted
  >;

export const duplicateComponentAcrossLocalesEnqueueSucceeded = createAction<
  typeof DUPLICATE_COMPONENT_ACROSS_LOCALES_ENQUEUE_SUCCEEDED,
  {taskId: string}
>(DUPLICATE_COMPONENT_ACROSS_LOCALES_ENQUEUE_SUCCEEDED);

export type DuplicateComponentAcrossLocalesEnqueueSucceededAction =
  DesignerActionFromCreator<
    typeof duplicateComponentAcrossLocalesEnqueueSucceeded
  >;

export const duplicateComponentAcrossLocalesProgressed = createAction<
  typeof DUPLICATE_COMPONENT_ACROSS_LOCALES_PROGRESSED,
  {progress: number}
>(DUPLICATE_COMPONENT_ACROSS_LOCALES_PROGRESSED);

export type DuplicateComponentAcrossLocalesProgressedAction =
  DesignerActionFromCreator<typeof duplicateComponentAcrossLocalesProgressed>;

export const duplicateComponentAcrossLocalesFailed = createAction<
  typeof DUPLICATE_COMPONENT_ACROSS_LOCALES_FAILED
>(DUPLICATE_COMPONENT_ACROSS_LOCALES_FAILED);

export type DuplicateComponentAcrossLocalesFailedAction =
  DesignerActionFromCreator<typeof duplicateComponentAcrossLocalesFailed>;
